module.exports = __webpack_public_path__ + "static/media/arrow-left.1f9f9c1b.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/icons/arrow-left.svg
// module id = 274
// module chunks = 0